import { createSelector } from '@reduxjs/toolkit';

import { selectRegionId } from './location';

export function isInRegionSelector(regions: number[]) {
  return createSelector([selectRegionId], regionId => regions.includes(regionId));
}
